import { defineNuxtPlugin } from '#app';

// Add types for client-side globals
declare global {
  interface Window {
    Intercom?: any;
    intercomSettings?: any;
    fbq?: any;
    _fbq?: any;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  // Only run on client-side
  if (typeof window === 'undefined') return;

  // Initialize Facebook Pixel
  const initFacebookPixel = () => {
    const f = window;
    if (f.fbq) return;
    const n = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    } as any);
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    if (s?.parentNode) {
      s.parentNode.insertBefore(t, s);
    }
    window.fbq('init', '1247326690367492');
    window.fbq('track', 'PageView');
  };

  // Initialize all client-side scripts
  const initialize = () => {
    initFacebookPixel();
  };

  // Run initialization when the app is mounted
  nuxtApp.hook('app:mounted', () => {
    initialize();
  });
});
